import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AngularFireAuthGuard } from '@angular/fire/auth-guard';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'tabs', loadChildren: './tabs/tabs.module#TabsPageModule', canActivate: [AngularFireAuthGuard] },
    {
        path: 'tires-detail/:id', loadChildren: './tires-detail/tires-detail.module#TiresDetailPageModule',
        canActivate: [AngularFireAuthGuard]
    },
    { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
    { path: 'tab5', loadChildren: './tab5/tab5.module#Tab5PageModule' },
    {
        path: 'movements-logs/:id', loadChildren: './movements-logs/movements-logs.module#MovementsLogsPageModule',
        canActivate: [AngularFireAuthGuard]
    },
    { path: '**', redirectTo: '' }
];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
